// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Cursor__cursor___jZRb_{opacity:0;position:absolute}.Cursor__isVisible___1RQ14,.Cursor__isVisibleShubham___35Bmx{animation-duration:1s;animation-iteration-count:infinite;animation-name:Cursor__cursorFrames___1EM9c;opacity:1}@keyframes Cursor__cursorFrames___1EM9c{0%{opacity:0}50%{opacity:1}to{opacity:0}}", ""]);
// Exports
exports.locals = {
	"cursor": "Cursor__cursor___jZRb_",
	"isVisible": "Cursor__isVisible___1RQ14",
	"isVisibleShubham": "Cursor__isVisibleShubham___35Bmx",
	"cursorFrames": "Cursor__cursorFrames___1EM9c"
};
module.exports = exports;
